import { BaseApi } from './baseApi';
export default class FieldValueApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.prefix = 'field-value';
    }
    upsertByMachineName(data) {
        return this.apiCall({
            method: 'POST',
            route: `${this.prefix}/by-machine-name`,
            data,
        });
    }
    deleteByMachineName(data) {
        return this.apiCall({
            method: 'DELETE',
            route: `${this.prefix}/by-machine-name`,
            data,
        });
    }
}
//# sourceMappingURL=fieldValueApi.js.map